import { render } from "./App.vue?vue&type=template&id=9ec6c0a0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tandongling/Documents/vue/vue-argon-dashboard-2-pro-v3.0.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__